/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AssetResponseDto,
  AssetURLResponseDto,
  AssetsUploadAssetBody,
} from '.././model';

import { apiInstance } from '../../whisApi.instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Upload a file asset
 */
export const Assets_uploadAsset = (
  assetsUploadAssetBody: AssetsUploadAssetBody,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (assetsUploadAssetBody.file !== undefined) {
    formData.append(`file`, assetsUploadAssetBody.file);
  }

  return apiInstance<AssetResponseDto>(
    {
      url: `/api/assets`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getAssetsUploadAssetMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Assets_uploadAsset>>,
    TError,
    { data: AssetsUploadAssetBody },
    TContext
  >;
  request?: SecondParameter<typeof apiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Assets_uploadAsset>>,
  TError,
  { data: AssetsUploadAssetBody },
  TContext
> => {
  const mutationKey = ['assetsUploadAsset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Assets_uploadAsset>>,
    { data: AssetsUploadAssetBody }
  > = (props) => {
    const { data } = props ?? {};

    return Assets_uploadAsset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssetsUploadAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof Assets_uploadAsset>>
>;
export type AssetsUploadAssetMutationBody = AssetsUploadAssetBody;
export type AssetsUploadAssetMutationError = void;

/**
 * @summary Upload a file asset
 */
export const useAssetsUploadAsset = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Assets_uploadAsset>>,
      TError,
      { data: AssetsUploadAssetBody },
      TContext
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Assets_uploadAsset>>,
  TError,
  { data: AssetsUploadAssetBody },
  TContext
> => {
  const mutationOptions = getAssetsUploadAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get asset by its fileName and redirect to blob storage
 */
export const Assets_getAsset = (
  fileName: string,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<AssetURLResponseDto>(
    { url: `/api/assets/${fileName}`, method: 'GET', signal },
    options,
  );
};

export const getAssetsGetAssetQueryKey = (fileName?: string) => {
  return ['api', 'assets', fileName] as const;
};

export const getAssetsGetAssetQueryOptions = <
  TData = Awaited<ReturnType<typeof Assets_getAsset>>,
  TError = void,
>(
  fileName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Assets_getAsset>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAssetsGetAssetQueryKey(fileName);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof Assets_getAsset>>> = ({
    signal,
  }) => Assets_getAsset(fileName, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!fileName,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof Assets_getAsset>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AssetsGetAssetQueryResult = NonNullable<
  Awaited<ReturnType<typeof Assets_getAsset>>
>;
export type AssetsGetAssetQueryError = void;

export function useAssetsGetAsset<
  TData = Awaited<ReturnType<typeof Assets_getAsset>>,
  TError = void,
>(
  fileName: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Assets_getAsset>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Assets_getAsset>>,
          TError,
          Awaited<ReturnType<typeof Assets_getAsset>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAssetsGetAsset<
  TData = Awaited<ReturnType<typeof Assets_getAsset>>,
  TError = void,
>(
  fileName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Assets_getAsset>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Assets_getAsset>>,
          TError,
          Awaited<ReturnType<typeof Assets_getAsset>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAssetsGetAsset<
  TData = Awaited<ReturnType<typeof Assets_getAsset>>,
  TError = void,
>(
  fileName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Assets_getAsset>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get asset by its fileName and redirect to blob storage
 */

export function useAssetsGetAsset<
  TData = Awaited<ReturnType<typeof Assets_getAsset>>,
  TError = void,
>(
  fileName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Assets_getAsset>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAssetsGetAssetQueryOptions(fileName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
